import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2deb24f2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "edit-userinfo-root main-scroll-topbar-content"
};
const _hoisted_2 = {
  class: "editinfo-content"
};
const _hoisted_3 = {
  class: "user-info-box"
};
const _hoisted_4 = {
  class: "avatar-box list-item"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "头像", -1));

const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "img-box"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "nickname-box list-item"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "昵称", -1));

const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = {
  class: "modify-btn"
};
import { ref, onBeforeMount } from "vue";
import { Toast } from "vant";
import TopNavigator from "../components/TopNavigator.vue";
import CommonBtn from "../components/CommonBtn.vue";
import router from "../router";
import AV from "../assets/utils/av";
export default {
  __name: 'EditUserinfo',
  props: {},

  setup(__props) {
    const props = __props; //获取用户数据

    const userOriData = ref({});
    onBeforeMount(() => {
      const userInfo = AV.User.current() && AV.User.current().toJSON();
      userOriData.value = userInfo || {};
    }); //头像上传前置处理

    const beforeRead = file => {
      if (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg") {
        return true;
      } else {
        Toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
    }; //头像上传后回调


    const afterRead = file => {
      //本地图片上传的对象
      // console.log('file after', file);
      //通过base64构建文件
      const data = {
        base64: file.content
      };
      const createfile = new AV.File("avatar", data);
      console.log("createfile", createfile);
      createfile.save().then(fileRes => {
        // console.log('头像上传成功', fileRes.attributes);
        userOriData.value.avatarUrl = fileRes.attributes.url;
        Toast.success("头像上传成功");
      }, error => {
        // 保存失败，可能是文件无法被读取，或者上传过程中出现问题
        console.log("头像上传失败", error);
        Toast.fail("头像上传失败");
      });
    }; //提交更改信息


    const submitUserInfo = () => {
      const user = AV.User.current(); //当前登录用户

      user.set("nickName", userOriData.value.nickName);
      user.set("avatarUrl", userOriData.value.avatarUrl);
      user.save().then(res => {
        // console.log("更改用户信息成功 ", res);
        Toast.success("更改用户信息成功");
        router.push("/mine");
      }).catch(err => {
        console.error("更改用户信息失败: ", err);
        Toast.fail("更改用户信息失败");
      });
    };

    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_uploader = _resolveComponent("van-uploader");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "hidden"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_van_uploader, {
        "before-read": beforeRead,
        "after-read": afterRead
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: userOriData.value.avatarUrl,
          alt: ""
        }, null, 8, _hoisted_8)]), _createElementVNode("div", null, [_createVNode(_component_van_icon, {
          name: "arrow",
          size: "20"
        })])])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userOriData.value.nickName = $event),
        type: "text",
        placeholder: userOriData.value.nickName,
        maxlength: "50"
      }, null, 8, _hoisted_12), [[_vModelText, userOriData.value.nickName]])])])]), _createElementVNode("div", _hoisted_13, [_createVNode(CommonBtn, {
        onHandleClick: submitUserInfo,
        text: "确认更改",
        width: "200px",
        heigth: "34px"
      })])])])], 64);
    };
  }

};